<div *ngIf="accessdenied" class="row">
    <div class="col-md-12 no-padding">
        <app-access-denied></app-access-denied>
    </div>
</div>
<div *ngIf="!accessdenied" class="row">
    <div class="col-xl-8 no-padding">
        <app-post-list [relatedTo]="'profile'" [relatedId]="'0'" [isNewsFeed]="'true'"></app-post-list>
    </div>
    <div class="col-xl-4" style="padding-right: 0px; padding-left: 30px;">
        <app-profile-edit-box *ngIf="!userData.isProfileComplete"></app-profile-edit-box>
        <!--<app-articles-box [title]="'Latest 5 articles'" [isUserArticles]="false" [userId]="'0'"></app-articles-box>-->
        <app-discussions-box [title]="'Latest 5 discussions'" [isUserDiscussions]="false" [userId]="'0'"></app-discussions-box>
        <app-connections-box></app-connections-box>
    </div>

</div>

